import React from "react";

const Checkbox = ({ label, checked, className, onChange }) => {
  const handleCheckboxChange = (e) => {
    if (onChange) {
      onChange(e.target.checked); 
    }
  };

  return (
    <div className="flex items-center">
      <input
        type="checkbox"
        className={`form-checkbox h-5 w-5 cursor-pointer text-blue-500 ${className}`}
        checked={checked}
        onChange={handleCheckboxChange}
      />
      <label className="ml-2 text-white">{label}</label>
    </div>
  );
};

export default Checkbox;

